<template>
  <CHeader with-subheader>
    <CToggler
      in-header
      class="ml-3 d-lg-none"
      @click="$store.commit('toggleSidebarMobile')"
    />
    <CToggler
      in-header
      class="ml-3 d-md-down-none"
      @click="$store.commit('toggleSidebarDesktop')"
    />
    <!-- <CHeaderBrand
      class="mx-lg-auto d-lg-none"
      src="~/img/brand/logo_skl.svg"
      width="97"
      height="46"
      alt="CoreUI Logo"
    /> -->
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <CBreadcrumbRouter class="my-1 border-0" />
    </div>
    <CHeaderNav class="d-md-down-none mr-auto"> </CHeaderNav>
    <CHeaderNav class="ml-auto mr-2">
      <CHeaderNavItem class="mx-2" v-if="$store.getters.getShowDropdownBrand">
        <b-dropdown
          id="dropdown-1"
          class="my-md-2 btn-brand-selected small-dropdown"
          right
          no-flip
        >
          <template v-slot:button-content>
            {{ getBrandDetail().name }}
          </template>
          <template>
            <b-dropdown-item
              v-for="(brand, index) in getBrandList()"
              v-bind:key="index"
              @click="clickChangeBrand(brand)"
              :class="{active : getBrandDetail().id === brand.id}"
            >
              {{ brand.name }}
            </b-dropdown-item>
          </template>
        </b-dropdown>
      </CHeaderNavItem>
      <CHeaderNavItem
        class="d-none d-md-block d-lg-block d-xl-block"
        v-if="getUserDetail()"
      >
        {{ getUserDetail().userName }}
      </CHeaderNavItem>

      <TheHeaderDropdownAccnt />
    </CHeaderNav>
  </CHeader>
</template>

<script>
import TheHeaderDropdownAccnt from "./TheHeaderDropdownAccnt";
import { mapGetters } from "vuex";

export default {
  name: "TheHeader",
  data() {
    return {
      displayName: "",
      name: "",
      modalMessage: "Are you sure you want to log out ?"
    };
  },
  created: async function() {
    await this.$store.dispatch("flowBuilder/fetchTierMasterdataList");
  },
  computed: {
    ...mapGetters([
      "getBrandDetail",
      "getBrandList",
      "getCurrentBrandID",
      "getUserDetail"
    ])
  },
  methods: {
    clickChangeBrand(brand) {
      let currentPath = this.$router.history.current.path;
      window.location.href = `${currentPath || '/flow-builder'}?brandID=${brand.id}`;
    }
  },
  components: {
    TheHeaderDropdownAccnt
  }
};
</script>

<style scoped>
::v-deep .lang-dd button {
  background-color: transparent;
  border: none;
  padding: 0;
}

::v-deep .lang-dd button:focus,
::v-deep .lang-dd button:active,
::v-deep .lang-dd.show > .btn-secondary.dropdown-toggle,
::v-deep .lang-dd button:hover {
  background-color: transparent !important;
  border: none;
  padding: 0;
}

.lang-dd {
  border: 1px solid #dcdcdc;
  padding: 5px 10px;
}

::v-deep .lang-dd ul {
  width: 100px;
}

.modal-header {
  border-bottom: 0 !important;
  margin: 0px;
  padding: 0px;
  padding-bottom: 0.25rem;
}

.text-msg {
  font-size: 2rem;
  color: #4a4a4a;
}

.btn-modal {
  width: 100px;
  font-weight: bold;
}

.text-text {
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 1.2rem;
}

.img {
  width: 100px;
}
::v-deep .active > .dropdown-item {
  text-decoration: none;
  color: #455164;
  background-color: #e2dff3;
}
::v-deep .dropdown-menu.dropdown-menu-right {
  padding: 0 !important;
}
</style>
